<template>
  <b-row
    id="onboarding-progress-id"
    :class="[
      {
        'tw-hidden md:tw-flex tw-py-[3.25rem]': isOnboardingRedesign,
        'd-none d-lg-none d-lg-flex py-4': !isOnboardingRedesign,
        'progress-header mt-xxl-6': true,
        '!tw-top-[10rem] md:!tw-top-[9rem] lg:!tw-top-[10rem]': !isOnboardingRedesign && $_fsaHsaPromo_isActiveFsaHsaPromo
      },
      {'checkout': page === 'checkout'},
      {'treatment-options': page === 'treatment-options'},
    ]"
    :style="{
      marginTop: elementBottom + 'px !important',
      top: '0 !important'
    }"
    align-v="center"
  >
    <b-col
      v-if="!isOnboardingRedesign"
      cols="1"
      class="pl-5"
    >
      <b-button
        v-if="!hide"
        class="back-btn"
        size="lg"
        variant="link"
        style="min-width: inherit"
        @click="backButton"
      >
        <img
          src="@/assets/images/small_back_arrow.svg"
        >
      </b-button>
    </b-col>
    <template v-if="!hide && isOnboardingRedesign">
      <portal
        to="back"
      >
        <b-button
          class="back-btn tw-mr-4"
          size="lg"
          variant="link"
          style="min-width: inherit"
          @click="backButton"
        >
          <!-- Back icon -->
          <svg
            width="19"
            height="15"
            viewBox="0 0 19 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.25 7.58594C0.25 7.32149 0.365476 7.08816 0.596428 6.88594L6.9806 0.877604C7.19506 0.68316 7.43839 0.585938 7.71058 0.585938C7.98277 0.585938 8.2096 0.671493 8.39106 0.842604C8.58077 1.01372 8.67563 1.23149 8.67563 1.49594C8.67563 1.62038 8.65088 1.74094 8.60139 1.8576C8.56015 1.97427 8.49417 2.07149 8.40343 2.14927L6.69604 3.8176L2.51416 7.37594L2.29145 6.8626L5.58252 6.64094H17.2621C17.559 6.64094 17.7982 6.73038 17.9797 6.90927C18.1612 7.08816 18.2519 7.31372 18.2519 7.58594C18.2519 7.85816 18.1612 8.08372 17.9797 8.2626C17.7982 8.44149 17.559 8.53094 17.2621 8.53094H5.58252L2.29145 8.30927L2.51416 7.8076L6.69604 11.3543L8.40343 13.0226C8.49417 13.1004 8.56015 13.1976 8.60139 13.3143C8.65088 13.4309 8.67563 13.5515 8.67563 13.6759C8.67563 13.9404 8.58077 14.1582 8.39106 14.3293C8.2096 14.5004 7.98277 14.5859 7.71058 14.5859C7.43839 14.5859 7.19506 14.4887 6.9806 14.2943L0.596428 8.28594C0.365476 8.08372 0.25 7.85038 0.25 7.58594Z"
              fill="#19191C"
            />
          </svg>
        </b-button>
      </portal>
    </template>
    <b-col
      :cols="isOnboardingRedesign ? 12 : 11"
      :class="{
        'pr-7': !isOnboardingRedesign,
        'tw-max-w-[1500px] tw-mx-auto md:tw-px-12 lg:tw-px-20': isOnboardingRedesign,
        'tw-mt-10': page === 'treatment-options' && onboardingPatient?.non_hrt
      }"
    >
      <b-row>
        <b-col
          v-for="(data, i) in progress"
          :key="data + i"
          cols="12"
          md="4"
          :class="data.value !== 0 ? '' : 'progress-disable'"
        >
          <template v-if="isOnboardingRedesign">
            <span class="tw-text-lg"> {{ data.title }} </span>
            <b-progress
              :value="data.value"
              :max="data.max"
              class="mb-1 step-progress"
              variant="purple"
              height="8px"
            />
          </template>
          <template v-else>
            <b-progress
              :value="data.value"
              :max="data.max"
              class="mb-1 step-progress"
              variant="purple"
              height="8px"
            />
            <span> {{ data.title }} </span>
          </template>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import { fsaHsaPromoMixin } from '@/mixins/fsaHsaPromo';
import calculateBottom from '@/mixins/calculateBottom';
export default {
  mixins: [fsaHsaPromoMixin, calculateBottom],
  props: {
    step: {
      type: String,
    },
    hide: {
      type: Boolean,
    },
    hideStep: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: [Object, Array],
      default: () => {},
    },
    page: {
      type: String,
      default: '',
    },
    elementId: {
      type: String,
      default: 'fixed-header',
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
  },
  methods: {
    backButton(event) {
      this.$emit('back', event);
    },
  },
};
</script>

<style></style>

<style lang="scss" scoped>
.progress-header {
  position: fixed;
  top: 80px;
  width: 100%;
  z-index: 100;
  background-color: #fff;

  @include media-breakpoint-up(sm) {
    top: 120px;
  }

  @include media-breakpoint-up(md) {
    top: 80px;
  }
}

.progress-header.checkout,
.progress-header.treatment-options {
  @include media-breakpoint-up(md) {
    //top: 66px;
  }
}

.progress-disable {
  opacity: 0.5;
}

.back-btn {
  @include media-breakpoint-up(xxl) {
    img {
      width: 25px * $scale-font;
      height: 13px * $scale-font;
    }
  }
}
</style>
